/**
 * Survey auto-advance
 */

(function($) {

    if ( typeof vous_l10n === 'undefined' ) { // Ensure l10n is set
        return;
    }
    if ( typeof vous_l10n.survey_form_id === 'undefined' || ! vous_l10n.survey_form_id ) { // Ensure script is enabled
        return;
    }

    /* Advance to the next page when option is selected */
    const autoadvance = function($this) {
        const $page = $this.closest('.gform_page');
        $page.closest('form').trigger('submit', [true]);
    };

    // Triggers when form is rendered
    $(document).on('gform_post_render', function(event, form_id, current_page) {
        if ( form_id != vous_l10n.survey_form_id ) { // Apply only to the survey form
            return;
        }

        const $autoadvance = $('.js-gfield-autoadvance');

        // Hide the next button
        $autoadvance.closest('.gform_page').find('.gform_next_button').addClass('is-hidden');

        // Advance to the next page when option is selected
        const $fields = $autoadvance.find('input[type="radio"]');
        $fields.on('change', function() {
            const $this = $(this);
            autoadvance($this);
        });
        $fields.siblings('label').on('click', function() {
            const $this = $(this);
            const $input = $this.siblings('input[type="radio"]');
            if ( $input.prop('checked') === true ) {
                autoadvance($this);
            }
        });
    });

})(jQuery);
